<template><div><h1>VUX 发布日志</h1>
<h2>next (未发布)</h2>
<h3>Selector</h3>
<ul><li><span style="font-size:15px;"><span class="change change-fix">fix</span>  修复direction=rtl时的中文括号显示异常 <a href="https://github.com/airyland/vux/issues/2864" target="_blank">#2864</a> </span></li></ul>
<h3>VChart</h3>
<ul><li><span style="font-size:15px;"><span class="change change-enhance">enhance</span>  v-point 可以设置size和shape, v-line 可以设置shape</span></li></ul>
<h2><a href="/zh-CN/changelog/v2.9.2.html">v2.9.2</a></h2>
<h3>Confirm</h3>
<ul><li><span style="font-size:15px;"><span class="change change-feature">feature</span>  支持 prop: showCancelButton showConfirmButton <a href="https://github.com/airyland/vux/issues/2795" target="_blank">#2795</a> </span></li></ul>
<h3>DatetimeView</h3>
<ul><li><span style="font-size:15px;"><span class="change change-fix">fix</span>  修复render错误，未找到DOM元素 <a href="https://github.com/airyland/vux/issues/2797" target="_blank">#2797</a> </span></li></ul>
<h3>Range</h3>
<ul><li><span style="font-size:15px;"><span class="change change-feature">feature</span>  新增on-touchstart 和 on-touchend事件 <a href="https://github.com/airyland/vux/issues/2804" target="_blank">#2804</a> </span></li></ul>
<h3>Swiper</h3>
<ul><li><span style="font-size:15px;"><span class="change change-fix">fix</span>  修复设置最小移动距离后滑动卡住 <a href="https://github.com/airyland/vux/issues/2773" target="_blank">#2773</a> </span></li><li><span style="font-size:15px;"><span class="change change-fix">fix</span>  修复在循环模式下重复设置数据的错误 <a href="https://github.com/airyland/vux/issues/2803" target="_blank">#2803</a> </span></li></ul>
<h3>XButton</h3>
<ul><li><span style="font-size:15px;"><span class="change change-feature">feature</span>  button支持样式变量 <a href="https://github.com/airyland/vux/issues/2748" target="_blank">#2748</a> </span></li></ul>
<h3>XImg</h3>
<ul><li><span style="font-size:15px;"><span class="change change-enhance">enhance</span>  支持设置separator属性 <a href="https://github.com/airyland/vux/issues/2744" target="_blank">#2744</a> </span></li></ul>
<h3>XInput</h3>
<ul><li><span style="font-size:15px;"><span class="change change-fix">fix</span>  修复设置 mask 时，光标错位的问题 <a href="https://github.com/airyland/vux/issues/2810" target="_blank">#2810</a> </span></li></ul>
<h2><a href="/zh-CN/changelog/v2.9.1.html">v2.9.1</a></h2>
<h3>Alert</h3>
<ul><li><span style="font-size:15px;"><span class="change change-feature">feature</span>  添加 isVisible 获取当前显示状态 <a href="https://github.com/airyland/vux/issues/2704" target="_blank">#2704</a> </span></li></ul>
<h3>Confirm</h3>
<ul><li><span style="font-size:15px;"><span class="change change-feature">feature</span>  添加 isVisible 获取当前显示状态 <a href="https://github.com/airyland/vux/issues/2704" target="_blank">#2704</a> </span></li></ul>
<h3>Loading</h3>
<ul><li><span style="font-size:15px;"><span class="change change-feature">feature</span>  添加 isVisible 获取当前显示状态 <a href="https://github.com/airyland/vux/issues/2704" target="_blank">#2704</a> </span></li><li><span style="font-size:15px;"><span class="change change-fix">fix</span>  修复使用类 scroll 组件时会被覆盖的问题</span></li></ul>
<h3>Popup</h3>
<ul><li><span style="font-size:15px;"><span class="change change-fix">fix</span>  修正弹出框右边有黑边 <a href="https://github.com/airyland/vux/issues/2651" target="_blank">#2651</a> </span></li></ul>
<h3>Qrcode</h3>
<ul><li><span style="font-size:15px;"><span class="change change-fix">fix</span>  修复中文支持 <a href="https://github.com/airyland/vux/issues/2652" target="_blank">#2652</a> </span></li></ul>
<h3>Tab</h3>
<ul><li><span style="font-size:15px;"><span class="change change-fix">fix</span>  修复全局 box-sizing 为 border-box 时导致的高度问题 <a href="https://github.com/airyland/vux/issues/2621" target="_blank">#2621</a> 。感谢 <a href="https://github.com/suncodeer" target="_blank">@suncodeer </a></span></li></ul>
<h3>Toast</h3>
<ul><li><span style="font-size:15px;"><span class="change change-feature">feature</span>  添加 isVisible 获取当前显示状态 <a href="https://github.com/airyland/vux/issues/2704" target="_blank">#2704</a> </span></li></ul>
<h3>XCircle</h3>
<ul></ul>
<h2><a href="/zh-CN/changelog/v2.9.0.html">v2.9.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.8.1.html">v2.8.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.8.0.html">v2.8.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.9.html">v2.7.9</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.8.html">v2.7.8</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.7.html">v2.7.7</a></h2>
<h2><a href="/zh-CN/changelog/2.7.6.html">2.7.6</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.6.html">v2.7.6</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.5.html">v2.7.5</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.4.html">v2.7.4</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.3.html">v2.7.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.2.html">v2.7.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.1.html">v2.7.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.0.html">v2.7.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.6.5.html">v2.6.5</a></h2>
<h2><a href="/zh-CN/changelog/v2.6.4.html">v2.6.4</a></h2>
<h2><a href="/zh-CN/changelog/v2.6.3.html">v2.6.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.6.2.html">v2.6.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.6.1.html">v2.6.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.6.0.html">v2.6.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.12.html">v2.5.12</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.11.html">v2.5.11</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.10.html">v2.5.10</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.9.html">v2.5.9</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.8.html">v2.5.8</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.7.html">v2.5.7</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.6.html">v2.5.6</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.5.html">v2.5.5</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.4.html">v2.5.4</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.3.html">v2.5.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.2.html">v2.5.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.1.html">v2.5.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.0.html">v2.5.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.4.1.html">v2.4.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.4.0.html">v2.4.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.8.html">v2.3.8</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.7.html">v2.3.7</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.6.html">v2.3.6</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.5.html">v2.3.5</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.4.html">v2.3.4</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.3.html">v2.3.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.2.html">v2.3.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.1.html">v2.3.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.2.html">v2.2.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1.html">v2.2.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.8.html">v2.2.1-rc.8</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.7.html">v2.2.1-rc.7</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.6.html">v2.2.1-rc.6</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.4.html">v2.2.1-rc.4</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.3.html">v2.2.1-rc.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.2.html">v2.2.1-rc.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.1.html">v2.2.1-rc.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.0.html">v2.2.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.14.html">v2.1.1-rc.14</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.13.html">v2.1.1-rc.13</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.12.html">v2.1.1-rc.12</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.11.html">v2.1.1-rc.11</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.10.html">v2.1.1-rc.10</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.9.html">v2.1.1-rc.9</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.8.html">v2.1.1-rc.8</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.7.html">v2.1.1-rc.7</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.6.html">v2.1.1-rc.6</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.5.html">v2.1.1-rc.5</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.4.html">v2.1.1-rc.4</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.3.html">v2.1.1-rc.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.2.html">v2.1.1-rc.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.1.html">v2.1.1-rc.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0.html">v2.1.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0-rc.51.html">v2.1.0-rc.51</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0-rc.50.html">v2.1.0-rc.50</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0-rc.49.html">v2.1.0-rc.49</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0-rc.48.html">v2.1.0-rc.48</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0-rc.47.html">v2.1.0-rc.47</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0-rc.46.html">v2.1.0-rc.46</a></h2>
<h2><a href="/zh-CN/changelog/v2.0.14.html">v2.0.14</a></h2>
<h2><a href="/zh-CN/changelog/v2.0.1.html">v2.0.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.0.0.html">v2.0.0</a></h2>
</div></template><script>
export default {
  head: {"title":"VUX 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// changelog-197.vue?acd64816